const MANAGEMENT_ROLES = new Set(['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_BOD', 'ROLE_MANAGER']);

const normalizeRoles = (roles) => (Array.isArray(roles) ? roles : [])
  .map((role) => {
    if (typeof role === 'string') return role.toUpperCase();
    if (role && typeof role === 'object') return String(role.name || '').toUpperCase();
    return '';
  })
  .filter(Boolean);

const collectUserRoles = (user) => normalizeRoles([
  user?.role,
  user?.roleName,
  ...(Array.isArray(user?.roles) ? user.roles : []),
]);

export const hasManagementRole = (roles) => normalizeRoles(roles).some((role) => MANAGEMENT_ROLES.has(role));

export const isSalesDashboardUser = (user) => collectUserRoles(user).includes('ROLE_SALES');

export const hasManagementJobTitle = (jobTitle) => {
  const normalized = String(jobTitle || '').toLowerCase();
  return normalized.includes('manager') || normalized.includes('head');
};

// Technical Reviewer, Certification Authority, and Certificate Issuer/Reviewer have no fixed
// CRM Role — they are all ROLE_AUDITOR + competency, identified only by which task type they
// currently hold on a given project (see AuditProcess's myProjectRole). This is the same set of
// codes used there, mirrored here so the dashboard can grant them broader ("INVOLVED" monitoring)
// visibility instead of the plain own-tasks-only staff view.
const BROADER_VISIBILITY_TASK_TYPE_CODES = new Set([
  'TECHNICAL_REVIEW',
  'ASSIGN_NEXT_PROCESS_TECHNICAL',
  'ASSIGN_NEXT_PROCESS_TECHNICAL_REVIEWER',
  'CERTIFICATE_DECISION',
  'CERTIFICATE_ISSUANCE',
  'ISSUE_CERTIFICATE',
  'ASSIGN_NEXT_PROCESS_CERTIFICATION_AUTHORITY',
  'ASSIGN_NEXT_PROCESS_CERTIFICATE_ISSUER',
]);

export const hasBroaderAuditVisibility = (tasks) => (Array.isArray(tasks) ? tasks : [])
  .some((task) => BROADER_VISIBILITY_TASK_TYPE_CODES.has(String(task?.taskTypeCode || '').toUpperCase()));

export const resolveDashboardTier = (user) => (
  hasManagementRole(collectUserRoles(user)) || hasManagementJobTitle(user?.jobTitle)
    ? 'management'
    : 'staff'
);
